import { SplitToGa } from './SplitToGa';
export function SplitToGoogleAnalytics(options) {
    if (options === void 0) { options = {}; }
    // SplitToGa integration factory
    function SplitToGoogleAnalyticsFactory(params) {
        return new SplitToGa(params.settings.log, options);
    }
    SplitToGoogleAnalyticsFactory.type = 'SPLIT_TO_GOOGLE_ANALYTICS';
    return SplitToGoogleAnalyticsFactory;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@splitsoftware/splitio-commons/esm/integrations/ga/SplitToGoogleAnalytics.js
// module id = 3906
// module chunks = 25